import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-336c9b9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import { isEmpty } from 'lodash'
import {
  addFirmwareInfo,
  queryFirmwareGatewayList,
  handleUploadFirmware,
  queryFirmwareChipList,
} from '@/api'
import { CODE_ENUM } from '@/common'
import { ElMessage, genFileId } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'firmware-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const { VUE_APP_BASE_URL } = process.env
const uploadAction = computed(() => {
  return VUE_APP_BASE_URL + handleUploadFirmware()
})

const uploadHeaders = {
  Authorization: 'Bearer ' + localStorage.getItem('WX_Authorization'),
}

const chipTypeOps = ref([])
const queryChipOps = async () => {
  const res: any = await queryFirmwareChipList()
  if (res?.code === 0) {
    chipTypeOps.value = res.data.map((item: any) => {
      return {
        label: item.chipType,
        value: item.chipType,
      }
    })
  }
}

const uploadRef = ref()
const handleExceed = (files: any) => {
  uploadRef.value!.clearFiles()
  const file = files[0]
  file.uid = genFileId()
  uploadRef.value!.handleStart(file)
  uploadRef.value!.submit()
}

const formRef = ref()

const formData: any = ref({
  firmwareVersion: '',
  productKey: '',
  productModel: '',
  chipType: '',
  fileList: [],
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryGatewayList()
      queryChipOps()
    }
  }
)

const validateFileList = (rule: any, value: any, callback: any) => {
  if (isEmpty(value)) {
    callback()
  } else {
    const failResult = value.some((item: any) => {
      return item?.response?.code !== 0
    })
    if (failResult) {
      callback('请重新上传文件')
    } else {
      callback()
    }
  }
}

const rules: any = {
  productModel: [{ required: true, message: '请选择' }],
  productKey: [{ required: true, message: '请选择' }],
  fileList: [
    { required: true, message: '请上传', type: 'array' },
    { validator: validateFileList },
  ],
  firmwareVersion: [{ required: true, message: '请输入' }],
  chipType: [{ required: true, message: '请选择' }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true

  const params = dealwithData()
  const res: any = await addFirmwareInfo({
    ...params,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg || '添加固件成功')
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

const gatewayList: any = ref([])
const queryGatewayList = async () => {
  const res: any = await queryFirmwareGatewayList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    gatewayList.value = res.data
  }
}

const dealwithData = () => {
  const { productModel, productKey, fileList, firmwareVersion, chipType } =
    formData.value
  const productName = gatewayList.value.filter(
    (item: any) => item.productKey === productKey
  )?.[0]?.productName

  const { path, firmwareName } = fileList[0].response.data
  return {
    productName,
    firmwareName,
    path,
    productModel,
    productKey,
    firmwareVersion,
    chipType,
  }
}

const productModelOps: any = ref([])
const onProductChange = (productKey: any) => {
  const value = gatewayList.value.filter(
    (item: any) => item.productKey === productKey
  )?.[0]?.productModel

  if (value) {
    productModelOps.value = [
      {
        label: value,
        value,
      },
    ]
    formData.value.productModel = value
  } else {
    productModelOps.value = []
    formData.value.productModel = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: "添加升级包",
    size: "480px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: submit,
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "产品名称",
            prop: "productKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                onChange: onProductChange,
                modelValue: formData.value.productKey,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.productKey) = $event)),
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gatewayList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.productKey,
                      label: item.productName,
                      value: item.productKey
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "硬件代码",
            prop: "productModel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.productModel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.productModel) = $event)),
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productModelOps.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "芯片类型",
            prop: "chipType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.chipType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.chipType) = $event)),
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chipTypeOps.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "固件版本",
            prop: "firmwareVersion"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.firmwareVersion,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.firmwareVersion) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入固件版本"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "固件文件",
            prop: "fileList",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                ref_key: "uploadRef",
                ref: uploadRef,
                "file-list": formData.value.fileList,
                "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.fileList) = $event)),
                headers: uploadHeaders,
                action: uploadAction.value,
                limit: 1,
                "on-exceed": handleExceed
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("上传固件")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "action"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})